export default {
  undefined: "UNDEFINED",
  copyright: "2025 — Avtala Sverige AB",
  badge: "Bricka",
  close: "Stäng",
  logout: "Logga ut",
  loading: "Laddar...",
  Error: "Ett fel inträffade!",
  error: {
    default: "Ett problem uppstod",
    request: "Anropet misslyckades",
    unauthorized: "Inloggning krävs",
    forbidden: "Behörighet saknas",
  },
  dataIterator: {
    noResultsText: "Inga poster funna",
    loadingText: "Laddar data...",
  },
  dataTable: {
    itemsPerPageText: "Rader per sida:",
    ariaLabel: {
      sortDescending:
        ": Sorterat fallande. Aktivera för att ta bort sortering.",
      sortAscending: ": Sorterat stigande. Aktivera för sortering fallande.",
      sortNone: ": Osorterat. Aktivera för sortering stigande.",
      activateDescending: "Aktivera för stigande sortering.",
      activateAscending: "Aktivera för fallande sortering.",
    },
    sortBy: "Sortera efter",
  },
  dataFooter: {
    itemsPerPageText: "Objekt per sida:",
    itemsPerPageAll: "Alla",
    nextPage: "Nästa sida",
    prevPage: "Föregående sida",
    firstPage: "Första sidan",
    lastPage: "Sista sidan",
    pageText: "{0}-{1} av {2}",
  },
  datePicker: {
    itemsSelected: "{0} markerade",
    prevMonthAriaLabel: "Föregående månad",
    nextMonthAriaLabel: "Nästa månad",
    prevYearAriaLabel: "Föregående år",
    nextYearAriaLabel: "Nästa år",
  },
  noDataText: "Ingen data tillgänglig",
  pagination: {
    ariaLabel: {
      previous: "Föregående sida",
      next: "Nästa sida",
      page: "Sida",
      currentPage: "Sida",
      wrapper: "Paginering",
    },
  },
  carousel: {
    prev: "Föregående vy",
    next: "Nästa vy",
    ariaLabel: {
      delimiter: "Karusell sida {0} av {1}",
    },
  },
  calendar: {
    moreEvents: "{0} fler",
  },
  input: {
    clear: "Töm {0}",
    prependAction: "{0}",
    appendAction: "{0}",
    otp: "Ange engångskod {0}",
  },
  fileInput: {
    counter: "{0} filer",
    counterSize: "{0} filer (av {1} totalt)",
  },
  timePicker: {
    am: "fm",
    pm: "em",
  },
  app: {
    home: "Hem",
    admin: "Administration",
    menu: {
      modules: "Moduler",
      history: "Historik",
    },
    reload: "Uppdatera",
    error: {
      generic: "Ett fel inträffade!",
      avatar: {
        get: "Ett problem uppstod då din profilbild skulle hämtas",
      },
      save: "Det gick inte att spara informationen. Försök igen senare och kontakta support om problemen kvarstår.",
    },
  },
  avtala: {
    app: {
      accounts: {
        label: "Mina organisationer",
      },
    },
    dashboard: {
      label: "Aktuellt",
      invitations: "Inbjudningar",
      invitation: {
        label: "Inbjudan från {0}",
        text: "Du har fått en inbjudan från {0} gällande åtkomst till databasen {1}",
        accept: "Acceptera",
        deny: "Avböj",
      },
      todo: {
        title: "Aktuellt - {0}",
        empty: "Inget aktuellt just nu",
      },
      activity: {
        title: "Senaste aktiviteter",
        empty: "Inga aktiviteter",
      },
      contacts: {
        title: "Mina kontakter",
        empty: "Kontakter markerade som 'favorit' visas här",
      },
    },
    calendar: {
      label: "Kalender",
      title: "Kalender",
    },
    timeline: {
      label: "Tidslinje",
      title: "Tidslinje",
    },
    admin: {
      label: "Administration",
      title: "Administration",
    },
    contract: {
      name: "Avtalsnamn",
      number: "Avtalsnummer",
      number2: "Kostnadsställe",
      product: "Produkt",
      address: "Adress",
      view: "Avtalsvy",
      type: "Avtalstyp",
      category: "Avtalskategori",
      status: "Avtalsstatus",
      period: "Avtalsperiod",
      startDate: "Perioden startar",
      endDate: "Perioden slutar",
      terminated: "Uppsagt datum",
      cancelDate: "Uppsägning senast",
      cancelOffset: "Uppsägningstid",
      cancelOffsetHint: "Antal dagar / månader",
      autoExtended: "Förlängning",
      autoExtendedHint: "Antal månader avtalet förlängs om det inte sägs upp",
      autoExtendedMax: "Max förlängning",
      autoExtendedMaxHint: "Max antal månader som avtalet förlängs",
      currency: "Valuta",
      value: "Kostnad/intäkt",
      valueHint: "Per Månad",
      description: "Beskrivning",
      descriptionHint: "Beskrivning av avtalsobjektet",
      responsible: "Avtalsansvarig",
      group: "Grupp",
      tags: "Etiketter",
      access: "Åtkomst",
      follow: "Följ avtalet för att få notiser",
      details: "Detaljer",
      parties: {
        title: "Avtalsparter",
        search: "Sök och välj parter nedan",
        noResult: "Inga företag eller personer matchar sökningen",
      },
      contacts: {
        title: "Avtalsparter",
        add: {
          company: "Nytt företag",
          person: "Ny person",
          user: "Lägg till användare eller grupp",
        },
        edit: {
          company: "Redigera avtalspart",
          person: "Redigera avtalspart",
          selected: "Redigera markerad avtalspart",
        },
        delete: {
          selected: "Ta bort markerad avtalspart",
          confirm: {
            title: "Bekräfta borttag av avtalspart",
            text: "Är du säker på att du vill ta bort avtalsparten från avtalet?",
          },
        },
      },
      users: {
        label: "Användare / team",
        add: {
          title: "Lägg till användare",
          user: {
            label: "Användare",
          },
          role: {
            label: "Roll",
          },
          expires: {
            label: "Behörigheten gäller t.o.m.",
          },
          orderIndex: {
            label: "Ordning",
          },
          notes: {
            label: "Kommentar",
          },
        },
        edit: {
          title: "Redigera användare",
        },
      },
      summary: {
        title: "Sammanfattning",
      },
      facts: {
        title: "Fakta",
      },
      periods: {
        title: "Perioder",
        current: "Aktuell period",
      },
      files: {
        label: "Dokument",
        title: "Dokument",
        nodata: "Inga filer är associerade med detta avtal.",
        toggleView: "Växla mellan listvy och miniatyrer",
        upload: {
          help: "Ladda upp dokument",
          label: "Tryck här för att ladda upp filer.",
        },
      },
      reminders: {
        title: "Påminnelser",
      },
      notifications: {
        label: "Prenumerera på notiser för:",
        reminders: "Påminnelser",
        comments: "Kommentarer",
        updates: "Uppdateringar,",
      },
      cancel: {
        none: "ingen uppsägningstid",
        days: "dagar",
        date: "specifikt datum",
        months: "månad(er)",
      },
      role: {
        label: "Roller",
        select: "Välj vilka roller {0} har",
        notes: "Notering",
      },
      findOrCreate: {
        title: "Lägg till avtalspart",
      },
      overview: {
        label: "Översikt",
        title: "Avtalsöversikt",
        name: "Avtalsnamn",
        contact: "Avtalspart",
        endDate: "Löper ut",
        status: "Status",
        team: "Team",
        tags: "Etiketter",
        value: "Värde",
        totals: "Totalt {0} st avtal",
      },
      list: {
        label: "Sök avtal",
        title: "Sök avtal",
        fromStartDate: "Fr.o.m startdatum",
        toStartDate: "T.o.m startdatum",
        fromEndDate: "Fr.o.m slutdatum",
        toEndDate: "T.o.m slutdatum",
        docs: {
          label: "Dokument och filer",
          help: "Ange titel, filnamn eller ord i dokumentet",
        },
        search: "Utför sökning",
        clear: "Töm fält",
        keepOpen: "Behåll öppen",
        fromInvoiceDate: "Fr.o.m fakturadatum",
        toInvoiceDate: "T.o.m fakturadatum",
        noInvoice: "Exkludera",
      },
      create: {
        label: "Nytt avtal",
        title: "Registrera nytt avtal",
        documents: {
          title: "Dokument",
          subTitle:
            "Om avtalet består av flera dokument eller är inskannade som flera filer, ladda först upp den fil som innehåller avtalsparternas namn och organisationsnummer.",
        },
        contacts: {
          title: "Avtalsparter",
          subTitle: "Avtalets ingående parter",
        },
        facts: {
          title: "Fakta",
          subTitle: "Avtalsnummer, benämning och kategorisering",
        },
        period: {
          title: "Avtalstid",
          subTitle: "Avtalets aktuella period och uppsägningstid",
        },
        team: {
          title: "Team",
          subTitle: "Avtalsanvändare som får notiser vid viktiga datum",
        },
        button: {
          save: "Registrera avtalet",
          cancel: "Avbryt registreringen",
        },
      },
      show: {
        label: "Visa avtal",
        title: "Visa avtal",
        facts: "Fakta",
        period: {
          add: {
            label: "Skapa ny period",
          },
        },
      },
      edit: {
        title: "Ändra avtalsfakta",
        label: "Redigera avtalsuppgifter",
      },
      delete: {
        label: "Ta bort detta avtal",
      },
      export: {
        title: "Exportera",
      },
      email: {
        label: "Skicka e-post",
      },
      share: {
        label: "Skapa bokmärke",
      },
      map: {
        label: "Visa på karta",
      },
      chart: {
        title: "Kostnader",
      },
      followup: {
        label: "Uppföljning",
        title: "Uppföljning",
      },
      comment: {
        title: "Kommentarer",
        nodata:
          "Bli den första att kommentera detta avtal. Tryck här för att skriva en kommentar.",
        help: "Skriv ny kommentar",
      },
      policies: {
        label: "Behörigheter",
        title: "Behörigheter",
        team: "Användare som ingår i avtalets team",
        contract: {
          read: "Läsa avtal",
          create: "Registrera avtal",
          update: "Ändra avtal",
          delete: "Radera avtal",
        },
        comment: {
          read: "Läsa kommentarer",
          create: "Skriv kommentarer",
          update: "Ändra kommentarer",
          delete: "Radera kommentarer",
        },
        content: {
          read: "Läsa dokument",
          create: "Ladda upp dokument",
          update: "Ändra dokument",
          delete: "Radera dokument",
        },
      },
      requirements: {
        title: "Checklista",
      },
      invoice: {
        title: "Fakturering",
      },
      search: {
        label: "Sök dokument",
        title: "Dokumentlista",
        company: "Sök företag...",
        person: "Sök personer...",
        contact: "Sök företag eller personer...",
        hint: "Ange namn eller organisations/person-nummer för att söka",
        nodata:
          "Ingen kontakt hittades i adressregistret. Tryck på + för att registrera en ny avtalspart.",
      },
      timeline: {
        title: "{0}",
      },
      requirement: {
        title: "Krav",
      },
      workflow: {
        add: {
          title: "Skapa ny {0}",
          help: "Skapa ny åtgärd / påminnelse",
        },
        edit: {
          title: "Redigera {0}",
        },
        view: {
          title: "Inställningar för avtalsvy",
        },
        category: {
          title: "Inställningar för avtalskategori",
        },
        contract: {
          title: "Inställningar för detta avtal",
        },
        settings: {
          label: "Inställningar",
        },
        name: {
          label: "Benämning",
          help: 'Namn på åtgärden, t.ex. "Påminnelse om indexuppräkning"',
        },
        action: {
          label: "Typ av åtgärd",
        },
        forced: {
          label: "Utför åtgärd även om avtalet är inaktivt",
        },
        relativeDateAction: {
          title: "Åtgärd relativt avtalsperioden",
          days: {
            label: "Antal dagar",
            help: "Antal dagar relativt referensdatum",
          },
          relative: {
            label: "Relativt",
            help: "Ange före eller efter referensdatumet",
            options: {
              before: "före",
              after: "efter",
            },
          },
          field: {
            label: "Datum",
            help: "Referensdatum",
            options: {
              START_DATE: "Startdatum",
              END_DATE: "Slutdatum",
              CANCEL_DATE: "Uppsägningsdatum",
              CREATE_DATE: "Registreringsdatum",
            },
          },
          time: {
            label: "Klockslag",
            help: "Tid på dygnet då åtgärden utförs",
          },
          adjust: {
            label: "Datumjustering",
            help: "Justering av datum för åtgärden",
            options: {
              NONE: "Ingen justering",
              FIRST_DAY_OF_MONTH: "Första dagen i månaden",
              LAST_DAY_OF_MONTH: "Sista dagen i månaden",
            },
          },
        },
        fixedDateAction: {
          title: "Åtgärd vid specifikt datum",
          date: { label: "Datum" },
          time: { label: "Klockslag" },
        },
        cronDateAction: {
          title: "Repeterande åtgärd",
          month: {
            label: "Månad",
            help: "Månad då åtgärden ska utföras, eller blankt för alla månader",
          },
          dayOfMonth: {
            label: "Dag",
            help: "Dag i månaden då åtgärden ska utföras, eller blankt för alla dagar",
          },
          dayOfWeek: {
            label: "Veckodag",
            help: "Veckodag då åtgärden ska utföras, eller blankt för oberoende av veckodag",
          },
          time: {
            label: "Klockslag",
          },
        },
        sendEmailAction: {
          title: "Skicka notis via e-post",
          subject: {
            label: "Ämnesrad",
            help: "Ämnesrad för meddelandet",
          },
          from: {
            label: "Avsändare",
            help: "E-postadress för meddelandets avsändare. Lämna blankt för standardavsändare.",
          },
          to: {
            label: "Mottagare",
            help: "E-postadress för meddelandets mottagare. Lämna blankt för standardmottagare.",
          },
          template: {
            label: "Mall för meddelandet",
            help: "Välj e-postmall för meddelandet",
          },
          message: {
            label: "Meddelande",
            help: "Anpassat meddelande, eller lämna blankt för standardmeddelande",
          },
        },
        createInvoiceAction: {
          title: "Skapa faktura",
        },
      },
    },
    export: {
      templates: {
        title: "Skriv ut / exportera",
        subtitle: "Välj utskriftsformat",
        base: {
          docx: {
            title: "Microsoft Word",
          },
        },
      },
      started: "Utskrift av {0} startad {1}",
    },

    followup: {
      method: {
        MANUAL: "Manuell",
        SYSTEM: "Automatiskt",
      },
    },
  },

  crm: {
    default: {
      button: {
        new: "Ny",
        view: "Visa",
        save: "Spara",
        delete: "Ta bort",
        remove: "Ta bort",
        add: "Lägg till",
        close: "Stäng",
        cancel: "Avbryt",
        ok: "Ok",
        search: "Sök",
        more: "Mer...",
        confirm: "Bekräfta",
      },
    },
    general: {
      add: {
        label: "Lägg till ny {0}",
      },
    },
    tags: {
      label: "Etiketter",
      title: "Etiketter",
    },
    contact: {
      name: "Namn",
      companyName: "Företagsnamn",
      firstName: "Förnamn",
      middleName: "Mellannamn",
      lastName: "Efternamn",
      email: "E-post",
      phone: "Telefon",
      telephone: "Telefon",
      title: "Titel",
      sex: "Kön",
      number: "Org.nr/Personnr",
      number2: "Kundnr",
      description: "Beskrivning",
      origin: "Källa",
      orgnr: "Orgnr",
      address: {
        label: "Adress",
        address: "Gata / Box",
        address2: "Adressrad 2",
        postalCode: "Postnummer",
        city: "Ort",
        region: "Region/stat",
        country: "Land",
      },
      relation: "Relation",
      postal: "Postadress",
      visit: "Besöksadress",
      delivery: "Leveransadress",
      invoice: "Fakturaadress",
      web: "Hemsida",
      website: "Hemsida",
      social: "Social",
      internet: "Internet",
      twitter: "Twitter",
      facebook: "Facebook",
      instagram: "Instagram",
      linkedin: "LinkedIn",
      facts: {
        edit: "Redigera fakta",
      },
      tags: {
        label: "Etiketter",
      },
      relations: {
        title: "Relationer",
        primary: "Primär relation",
        to: "Relation till",
        notes: "Notering",
        search: {
          employer: "Arbetsgivare",
          hint: "Börja skriva för att söka",
          type: "Välj typ av relation",
        },
      },
      files: {
        label: "Filer",
      },
      avatar: {
        upload: "Välj bild...",
      },
      type: {
        label: "Typ",
        company: "Företag",
        person: "Person",
      },
      button: {
        add: "Ny kontakt",
      },
      show: {
        label: "Visa kontakt",
        contactInfo: "Kontaktuppgifter",
        facts: "Fakta",
        summary: "Sammanfattning",
      },
      list: {
        label: "Adressbok",
        title: "Adressbok",
        type: {
          all: "Alla kontakter",
          company: "Endast företag",
          person: "Endast personer",
        },
        search: "Utför sökning",
        clear: "Töm fält",
        stay: "Behåll öppen",
      },
      add: {
        title: "Registrera ny kontakt",
      },
      create: {
        label: "Registrera ny kontakt",
        title: "Registrera ny kontakt",
        company: {
          title: "Registrera nytt företag",
        },
        person: {
          title: "Registrera ny person",
        },
      },
      edit: {
        title: "Redigera kontaktuppgifter",
      },
      search: {
        title: "Sök kontakt",
        addContact: "Ny kontakt",
        searchHint: "Sök på person- eller företags-namn",
        nameOrAddress: "Sök namn eller adress",
      },
      company: {
        number: "Org.nr",
        number2: "Kundnr",
        relations: {
          title: "Relaterade kontakter",
        },
      },
      person: {
        number: "Personnr",
        number2: "Kundnr",
        relations: {
          title: "Relaterade kontakter",
        },
      },
      summary: {
        title: "Sammanfattning",
      },
      export: {
        templates: {
          title: "Skriv ut / exportera",
          subtitle: "Välj utskriftsformat",
        },
      },
    },
    content: {
      list: {
        filesTitle: "Filer",
        action: "",
      },
      edit: {
        title: "Redigera fil",
      },
      upload: {
        select: "Välj fil(er)",
      },
      access: {
        label: "Inställningar för åtkomst",
        anonymous: "Delad",
        authenticated: "Intern",
        private: "Privat",
      },
      status: {
        label: "Status",
        undefined: "",
        DRAFT: "Utkast",
        REVIEW: "Granskas",
        APPROVED: "Godkänd",
        PUBLISHED: "Publicerad",
        ACTIVE: "Aktiv",
        LOCKED: "Låst",
        ARCHIVED: "Arkiverad",
        DELETED: "Raderad",
      },
      title: "Titel",
      filename: "Filnamn",
      description: "Beskrivning",
      tags: "Etiketter",
      length: "Storlek",
      author: "Skapad av",
      timeModified: "Ändrad",
      password1: "Lösenord",
      password2: "Upprepa lösenord",
    },
    comment: {
      send: "Spara",
      messageHint: "Ny kommentar",
    },
    notification: {
      clearAll: "Rensa alla",
    },
    metadata: {
      contact: {
        relation: {
          type: "Relationstyp",
        },
      },
      contract: {
        type: "Avtalstyp",
        category: "Avtalskategori",
        status: "Avtalsstatus",
      },
      crm: {
        currency: "Valuta",
      },
    },
    role: {
      title: "Roll",
      name: "Kod",
      label: "Benämning",
      permissions: "Behörigheter",
      list: {
        title: "Användarroller",
      },
      owner: {
        label: "Kontoadministratör",
      },
      admin: {
        label: "Systemadministratör",
      },
      user: {
        label: "Användare",
      },
      viewer: {
        label: "Läsare",
      },
      guest: {
        label: "Läsare",
      },
    },

    activity: {
      startTime: {
        label: "Startar",
      },
      stopTime: {
        label: "Slutar",
      },
      name: {
        label: "Id",
      },
      title: {
        label: "Benämning",
      },
      description: {
        label: "Beskrivning",
      },
      progress: {
        label: "Status",
        "-1": "Avbokad",
        0: "Planerad",
        50: "Pågående",
        100: "Genomförd",
      },
      repeat: {
        label: "Upprepa",
        NONE: "Aldrig",
        DAY: "Varje dag",
        WEEK: "Varje vecka",
        MONTH: "Varje månad",
        YEAR: "Varje år",
      },
      tags: {
        label: "Etiketter",
      },
      location: {
        label: "Plats",
      },
      uri: {
        label: "Länk",
      },
      username: {
        label: "Ansvarig",
      },
      reminder: {
        label: "Påminnelse",
      },
      show: {
        label: "Aktivitet",
        title: "Aktivitet",
      },
      create: {
        label: "Ny aktivitet",
        title: "Registrera ny aktivitet",
      },
      edit: {
        label: "Ändra aktivitet",
        title: "Ändra aktivitet",
      },
    },
    form: {
      scope: {
        CONTRACT: "Avtal",
        CONTACT: "Kontakter",
        COMPANY: "Företag",
        PERSON: "Person",
      },
      dataType: {
        TEXT: "Text",
        INTEGER: "Heltal",
        DECIMAL: "Decimaltal",
        BOOLEAN: "Ja/Nej",
        DATE: "Datum",
        DATETIME: "Klockslag",
        SINGLE: "Enval",
        MULTIPLE: "Flerval",
        TABLE: "Tabell",
      },
    },
    invoice: {
      queue: {
        title: "Fakturering",
        status: {
          DRAFT: "Utkast",
          PENDING: "Köad",
          COMPLETED: "Klar",
          ERROR: "Fel",
        },
        deliveryType: {
          label: "Distribution",
          NONE: "Manuell",
          PRINT: "Utskrift",
          EMAIL: "E-post",
          PRINTSERVICE: "Utskriftstjänst",
          ELECTRONICINVOICE: "E-faktura",
        },
      },
      customer: {
        number: "Org.nr",
        number2: "Kundnr",
        name: "Namn",
      },
      address: "Adress",
      email: "E-post",
      telephone: "Telefon",
      number: "Fakturanr",
      invoiceDate: "Fakturadatum",
      dueDate: "Förfallodatum",
      ourReference: "Vår referens",
      yourReference: "Er referens",
      termsOfPayment: "Betalningsvillkor",
      text: "Fakturatext",
      total: "Netto",
      totalVat: "Moms",
      administrationFee: "Fakturaavgift",
      totalToPay: "Att betala",
      roundOff: "Öresavrundning",
    },
  },

  tenant: {
    editIcon: "Klicka för att ändra ikon",
    editLogo: "Klicka för att ändra logotyp",
    name: "Organisation",
    number: "Org.nr",
    email: "E-post",
    telephone: "Telefon",
    description: "Beskrivning",
    website: "Hemsida",
    update: "Uppdatera",
    address: {
      address: "Gata / Box",
      address2: "Adressrad 2",
      postalCode: "Postnr",
      city: "Ort",
      region: "Kommun",
      country: "Land",
    },
    invitation: {
      status: {
        created: "Skapad",
        accepted: "Accepterad",
        denied: "Avböjt",
      },
    },
    updated: "Organisationen uppdaterad",
  },

  user: {
    firstName: "Förnamn",
    lastName: "Efternamn",
    title: "Titel",
    email: "E-post",
    role: {
      label: "Roll",
      administrator: "Administratör",
      user: "Användare",
    },
    invite: {
      send: "Skicka inbjudan",
    },
    settings: {
      darkTheme: "Mörkt utseende",
      startView: {
        label: "Startvy vid inloggning",
        dashboard: "Aktuellt",
        overview: "Avtalsöversikt",
        search: "Sök avtal",
        calendar: "Kalender",
      },
      homeAddress: "Startadress för färdbeskrivningar",
    },
  },

  profile: {
    firstName: "Förnamn",
    lastName: "Efternamn",
    title: "Titel",
    company: "Företag",
    number: "Anställningsnummer",
    email: "E-post",
    telephone: "Telefon",
    bio: "Presentation",
    website: "Hemsida",
    extra1: "Övrigt 1",
    extra2: "Övrigt 2",
    extra3: "Övrigt 3",
    edit: {
      title: "Kontaktuppgifter",
      picture: "Klicka för att ändra profilbild",
      update: "Uppdatera",
      settings: "Inställningar",
    },
    updated: "Användarprofilen uppdaterad",
  },

  feature: {
    added: {
      message: "Egenskapen tillagd i användaprofilen",
    },
    removed: {
      message: "Egenskapen raderad från användaprofilen",
    },
    subscription: {
      label: "Abonnemang",
    },
    storage: {
      label: "Lagring",
    },
    feature: {
      label: "Funktion",
    },
    integration: {
      label: "Integration",
    },
    template: {
      label: "Dokumentmallar",
    },
  },
};
